<p-fluid>
    <div class="flex flex-col gap-6">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
                <label class="flex items-center gap-1 font-medium mb-1"><app-free-coin-icon /> Free Currency Type</label>
                <p-select class="w-full" [options]="currencyTypeOptions" optionLabel="label" optionValue="value" [disabled]="disabled()" [ngModel]="value().FreeCurrencyType" (ngModelChange)="setField('FreeCurrencyType', $event ?? '')" />
                <small class="mt-1 text-muted-color">
                    @if (value().FreeCurrencyType === 'default_cent') {
                        Cents mode: 1500 &rarr; 15.00
                    } @else {
                        Whole units: 1500 &rarr; 1,500
                    }
                </small>
            </div>
            <div>
                <label class="flex items-center gap-1 font-medium mb-1"><app-paid-coin-icon /> Paid Currency Type</label>
                <p-select class="w-full" [options]="currencyTypeOptions" optionLabel="label" optionValue="value" [disabled]="disabled()" [ngModel]="value().PaidCurrencyType" (ngModelChange)="setField('PaidCurrencyType', $event ?? '')" />
                <small class="mt-1 text-muted-color">
                    @if (value().PaidCurrencyType === 'default_cent') {
                        Cents mode: 1500 &rarr; 15.00
                    } @else {
                        Whole units: 1500 &rarr; 1,500
                    }
                </small>
            </div>
        </div>

        <div class="flex items-center gap-3">
            <p-checkbox inputId="show-free-currency" [binary]="true" [disabled]="disabled()" [ngModel]="value().ShowFreeCurrency" (ngModelChange)="setField('ShowFreeCurrency', $event)" />
            <label for="show-free-currency" class="flex items-center gap-1"><app-free-coin-icon /> Show free currency</label>
        </div>
        <div class="flex items-center gap-3">
            <p-checkbox inputId="show-paid-currency" [binary]="true" [disabled]="disabled()" [ngModel]="value().ShowPaidCurrency" (ngModelChange)="setField('ShowPaidCurrency', $event)" />
            <label for="show-paid-currency" class="flex items-center gap-1"><app-paid-coin-icon /> Show paid currency</label>
        </div>

        <div class="font-semibold">Initial Funds</div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
                <label class="flex items-center gap-1 font-medium mb-1"><app-free-coin-icon /> Initial Free Credits</label>
                <p-inputNumber class="w-full" [disabled]="disabled()" [ngModel]="value().InitialFunds.FreeCredits" (ngModelChange)="setInitialFunds('FreeCredits', $event ?? 0)" />
            </div>
            <div>
                <label class="flex items-center gap-1 font-medium mb-1"><app-paid-coin-icon /> Initial Paid Credits</label>
                <p-inputNumber class="w-full" [disabled]="disabled()" [ngModel]="value().InitialFunds.PaidCredits" (ngModelChange)="setInitialFunds('PaidCredits', $event ?? 0)" />
            </div>
        </div>

        <div class="font-semibold">Credits per Dollar</div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
                <label class="flex items-center gap-1 font-medium mb-1"><app-free-coin-icon /> Free Credits per Dollar</label>
                <p-inputNumber class="w-full" [disabled]="disabled()" [ngModel]="value().CreditsPerDollar.FreeCredits" (ngModelChange)="setCreditsPerDollar('FreeCredits', $event ?? 0)" />
            </div>
            <div>
                <label class="flex items-center gap-1 font-medium mb-1"><app-paid-coin-icon /> Paid Credits per Dollar</label>
                <p-inputNumber class="w-full" [disabled]="disabled()" [ngModel]="value().CreditsPerDollar.PaidCredits" (ngModelChange)="setCreditsPerDollar('PaidCredits', $event ?? 0)" />
            </div>
        </div>
    </div>
</p-fluid>
